import axios from "../../../../utils/request"

function GET_LIST(params) {
    return axios.get("/batch/customer/getInfo", {
        params: {
            ...params
        }
    } )
}
function GET_TABLE_LIST(params) {
    return axios.get("/batch/BatchRecord/record", {
        params: {
            ...params
        }
    } )
}
function GET_IMPORT(params) {
    return axios.get("/batch/fileLib/selects", {
        params: {
            ...params
        }
    } )
}
function GET_NAME(params) {
    return axios.get("/translation/BatchTranslation/customerList", {
        params: {
            ...params
        }
    } )
}

function EDIT_DATA(params) {
    return  axios.post("/batch/customer/getinfo",
        {id:params}
    )
}
function GET_LOAD(params) {
    return axios.get("/batch/FileLib/template", {
        params: {
            ...params
        }
    } )
}
function IMPORT(params) {
    return axios.post("/batch/fileLib/import", {
        params:{...params}
        } )
}
function GET_CLASS(params) {
    return axios.get("/batch/fileLib/downloadCategory", {
        params: {
            ...params
        }
    } )
}

export default {
    GET_LIST,
    EDIT_DATA,
    GET_IMPORT,
    GET_NAME,
    GET_LOAD,
    IMPORT,
    GET_CLASS,
    GET_TABLE_LIST
}
